"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importStar(require("react"));
var ThemedVoiceStyles_1 = __importDefault(require("./ThemedVoiceStyles"));
var VoiceOrb_1 = require("./VoiceOrb");
var voiceTheme_1 = require("./voiceTheme");
var thinking_1 = require("./thinking");
var voiceScreenState_1 = require("./voiceScreenState");
var icons_1 = require("./icons");
var FONT_URL = 'https://fonts.googleapis.com/css2?family=Mulish:wght@400;500;600;700;800&display=swap';
// Sent to the widget (javascript-xdk Webview.js) to go back to the mode selector.
var BACK_TO_WIDGET_MESSAGE = 'https://haptik-webview//perform-action?action=back';
var DOTS = {
    live: [31, 193, 107],
    warn: [232, 161, 0],
    idle: null,
};
// Status row height + orb margin + half the orb: where the aura is centred.
var AURA_TOP = 144;
// Only http(s) links from the URL param; anything else is dropped.
var safeUrl = function (url) {
    return url && /^https?:\/\//i.test(url) ? url : null;
};
var isEmbedded = function () {
    try {
        return window.parent !== window;
    }
    catch (e) {
        return true;
    }
};
var buttonBase = {
    width: '100%',
    height: 48,
    borderRadius: 14,
    fontFamily: 'inherit',
    fontSize: 15,
    fontWeight: 700,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 8,
    cursor: 'pointer',
};
var primaryButton = function (theme) { return (__assign(__assign({}, buttonBase), { border: 0, background: theme.brand, color: theme.onBrand, boxShadow: "0 10px 24px " + theme.tint24 })); };
var secondaryButton = function (theme) { return (__assign(__assign({}, buttonBase), { border: "1px solid " + theme.line, background: theme.surface, color: theme.text })); };
var roundButton = {
    position: 'relative',
    width: 56,
    height: 56,
    flex: 'none',
    borderRadius: '50%',
    display: 'grid',
    placeItems: 'center',
    cursor: 'pointer',
};
var enterAnimation = 'vw-in .45s cubic-bezier(.4,0,.2,1) both';
var ThemedVoiceScreen = function (_a) {
    var brandColor = _a.brandColor, privacyUrlParam = _a.privacyUrl, isLoading = _a.isLoading, isCalling = _a.isCalling, isCallConnected = _a.isCallConnected, isMuted = _a.isMuted, isBotSpeaking = _a.isBotSpeaking, isUserSpeaking = _a.isUserSpeaking, callDuration = _a.callDuration, callError = _a.callError, onStart = _a.onStart, onToggleMute = _a.onToggleMute, onEnd = _a.onEnd, onRetry = _a.onRetry;
    var theme = react_1.useMemo(function () { return voiceTheme_1.voiceTheme(brandColor); }, [brandColor]);
    var privacyUrl = safeUrl(privacyUrlParam);
    var isThinking = thinking_1.useThinking({
        isCallConnected: isCallConnected,
        isMuted: isMuted,
        isBotSpeaking: isBotSpeaking,
        isUserSpeaking: isUserSpeaking,
    });
    var screen = voiceScreenState_1.getVoiceScreen({
        callError: callError,
        isCalling: isCalling,
        isCallConnected: isCallConnected,
        isMuted: isMuted,
        isBotSpeaking: isBotSpeaking,
        isUserSpeaking: isUserSpeaking,
        isThinking: isThinking,
    });
    var config = voiceScreenState_1.SCREENS[screen];
    var dot = DOTS[config.dot];
    var status = config.status || "On call \u00B7 " + voiceScreenState_1.formatCallClock(callDuration);
    react_1.useEffect(function () {
        if (document.querySelector("link[href=\"" + FONT_URL + "\"]"))
            return;
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = FONT_URL;
        document.head.appendChild(link);
    }, []);
    var typeInstead = function () {
        window.parent.postMessage(BACK_TO_WIDGET_MESSAGE, '*');
    };
    return (react_1["default"].createElement("div", { className: "vw-root", style: {
            position: 'relative',
            width: '100%',
            height: '100vh',
            overflow: 'hidden',
            display: 'flex',
            flexDirection: 'column',
            background: theme.surface,
            color: theme.text,
        } },
        react_1["default"].createElement(ThemedVoiceStyles_1["default"], null),
        react_1["default"].createElement(VoiceOrb_1.VoiceAura, { theme: theme, config: config, top: AURA_TOP }),
        react_1["default"].createElement("div", { style: {
                position: 'relative',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 6,
                padding: '14px 16px 0',
                fontSize: 12,
                lineHeight: '14px',
                fontWeight: 600,
                color: theme.muted,
            } },
            react_1["default"].createElement("span", { "aria-hidden": "true", style: {
                    width: 6,
                    height: 6,
                    borderRadius: '50%',
                    background: dot ? "rgb(" + dot.join(',') + ")" : '#8C929D',
                    boxShadow: dot ? "0 0 0 3px rgba(" + dot.join(',') + ",.18)" : 'none',
                    transition: 'background .4s ease, box-shadow .4s ease',
                } }),
            react_1["default"].createElement("span", { style: { fontVariantNumeric: 'tabular-nums' } }, status)),
        react_1["default"].createElement("div", { style: {
                position: 'relative',
                flex: 1,
                minHeight: 0,
                overflowY: 'auto',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                paddingBottom: 12,
            } },
            config.orb ? (react_1["default"].createElement("div", { style: { marginTop: 40 } },
                react_1["default"].createElement(VoiceOrb_1.VoiceOrb, { theme: theme, config: config }))) : (react_1["default"].createElement("div", { "aria-hidden": "true", style: {
                    marginTop: 64,
                    width: 92,
                    height: 92,
                    flex: 'none',
                    borderRadius: 30,
                    background: theme.raise,
                    border: "1px solid " + theme.line,
                    boxShadow: '0 14px 34px rgba(16,18,24,.10)',
                    display: 'grid',
                    placeItems: 'center',
                    color: theme.text,
                    animation: enterAnimation,
                } }, config.icon === 'lock' ? react_1["default"].createElement(icons_1.LockIcon, null) : react_1["default"].createElement(icons_1.HeadsetIcon, null))),
            react_1["default"].createElement("div", { "aria-live": "polite", style: { width: '100%' } },
                react_1["default"].createElement("div", { key: config.title, style: {
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        gap: 6,
                        marginTop: 24,
                        padding: '0 28px',
                        textAlign: 'center',
                        animation: enterAnimation,
                    } },
                    react_1["default"].createElement("h2", { style: {
                            margin: 0,
                            fontSize: 24,
                            lineHeight: '30px',
                            fontWeight: 800,
                            letterSpacing: '-0.015em',
                            color: theme.text,
                        } }, config.title),
                    react_1["default"].createElement("p", { style: {
                            margin: 0,
                            fontSize: 14,
                            lineHeight: '20px',
                            color: theme.muted,
                            maxWidth: 290,
                        } }, config.subtitle))),
            config.cta && (react_1["default"].createElement("div", { style: {
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: 12,
                    marginTop: 26,
                    width: '100%',
                    padding: '0 32px',
                    animation: enterAnimation,
                } },
                react_1["default"].createElement("button", { type: "button", className: "vw-btn", onClick: onStart, disabled: isLoading, style: __assign(__assign({}, primaryButton(theme)), { opacity: isLoading ? 0.6 : 1 }) },
                    react_1["default"].createElement(icons_1.MicIcon, null),
                    react_1["default"].createElement("span", null, "Start conversation")),
                react_1["default"].createElement("p", { style: {
                        margin: 0,
                        fontSize: 12,
                        lineHeight: '18px',
                        color: theme.muted,
                        textAlign: 'center',
                    } }, "We\u2019ll ask to use your microphone. Calls may be recorded to improve service."))),
            config.icon && (react_1["default"].createElement("div", { style: {
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 10,
                    marginTop: 22,
                    width: '100%',
                    padding: '0 28px',
                    animation: enterAnimation,
                } },
                config.steps && (react_1["default"].createElement("ol", { style: {
                        margin: '0 0 6px',
                        padding: '12px 14px 12px 34px',
                        borderRadius: 14,
                        background: theme.chip,
                        border: "1px solid " + theme.line,
                        fontSize: 13,
                        lineHeight: '20px',
                        color: theme.text,
                        textAlign: 'left',
                    } },
                    react_1["default"].createElement("li", null, "Select the lock icon next to the site address"),
                    react_1["default"].createElement("li", null, "Set Microphone to Allow, then try again"))),
                react_1["default"].createElement("button", { type: "button", className: "vw-btn", onClick: onRetry, style: primaryButton(theme) }, "Try again"),
                isEmbedded() && (react_1["default"].createElement("button", { type: "button", className: "vw-btn", onClick: typeInstead, style: secondaryButton(theme) }, "Type instead"))))),
        config.controls && (react_1["default"].createElement("div", { style: {
                position: 'relative',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 20,
                padding: '6px 0 20px',
            } },
            react_1["default"].createElement("button", { type: "button", className: "vw-btn", "aria-label": isMuted ? 'Unmute microphone' : 'Mute microphone', "aria-pressed": isMuted, disabled: config.micDisabled, onClick: onToggleMute, style: __assign(__assign({}, roundButton), { border: "1px solid " + (isMuted ? 'transparent' : theme.line), background: isMuted ? theme.text : theme.raise, color: isMuted ? theme.surface : theme.ink, boxShadow: '0 8px 20px rgba(16,18,24,.10)', opacity: config.micDisabled ? 0.4 : 1 }) }, isMuted ? react_1["default"].createElement(icons_1.MicOffIcon, null) : react_1["default"].createElement(icons_1.MicIcon, null)),
            react_1["default"].createElement("button", { type: "button", className: "vw-btn", "aria-label": "End call", onClick: onEnd, style: __assign(__assign({}, roundButton), { border: 0, background: '#D00416', color: '#FFFFFF', boxShadow: '0 10px 22px rgba(208,4,22,.28)' }) },
                react_1["default"].createElement(icons_1.EndCallIcon, null)))),
        react_1["default"].createElement("div", { style: {
                position: 'relative',
                display: 'flex',
                alignItems: 'center',
                justifyContent: privacyUrl ? 'space-between' : 'center',
                padding: '11px 18px 13px',
                borderTop: "1px solid " + theme.line,
                fontSize: 11.5,
                lineHeight: '14px',
                color: theme.muted,
            } },
            privacyUrl && (react_1["default"].createElement("a", { className: "vw-link", href: privacyUrl, target: "_blank", rel: "noopener noreferrer", style: { color: theme.muted, textUnderlineOffset: 3 } }, "Privacy & data")),
            react_1["default"].createElement("span", null,
                "Powered by",
                ' ',
                react_1["default"].createElement("strong", { style: { color: theme.text, fontWeight: 800 } }, "haptik")))));
};
exports["default"] = ThemedVoiceScreen;
